<template>
  <!-- eslint-disable max-len -->
  <v-card class="pa-8" style="position: relative">
    <div>
      <h2 class="text-center">機械雲軟體開發者與店中店營運商合作契約</h2>
      <p class="my-8">
        立約人○○○○○○公司（以下簡稱「甲方」）及財團法人工業技術研究院（以下簡稱「乙方」）。緣乙方為執行經濟部○○○科專計畫，由甲乙雙方就機械雲店中店之合作事宜（以下簡稱「本合作」），特立本契約，並同意條件如下：
      </p>
      <h3>第一條：名詞定義</h3>
      <p class="mt-1 mb-8">
        一、管理者：乙方或乙方指定之第三人。<br />
        二、服務中心：由管理者負責維運之「機械雲店中店」之服務與管理中心。<br />
        三、開發者：依照本契約約定透過「機械雲店中店」發布「產品」的甲方及甲方人員。<br />
        四、產品：「開發者」透過「機械雲店中店」提供的軟體、著作、數位資料與文件及其他商品或服務。<br />
        五、智慧財產權：技術、資料、文件等及其所已獲得或可能獲得之專利權、著作權、商標權、營業秘密、電路布局權及其他智慧財產權。<br />
        六、帳款處理機構：乙方或經由乙方授權提供帳款服務的機構或廠商，使「開發者」得以向使用者收費。<br />
        七、開發者帳戶：
        由「開發者」向「帳款處理機構」申請後，經由「帳款處理機構」提供之帳戶。「開發者」同意由「帳款處理機構」代為收取透過「機械雲店中店」銷售之「產品」之款項；及轉匯「服務費用」及其它費用予乙方及「帳款處理機構」。<br />
        八、服務費用：乙方及「帳款處理機構」因提供服務所收取之費用。
      </p>
      <h3>第二條：雙方合意</h3>
      <p class="mt-1 mb-8">
        一、雙方同意依下列條件，由乙方提供「機械雲店中店」供甲方於其上發布軟體、內容、數位內容和其他商品與服務(以下簡稱「產品」)，供使用者下載使用。<br />
        二、「開發者」同意其所提報之「產品」售價均為含稅價。<br />
        三、「開發者」同意，甲方「產品」之交易行為存在於甲方與使用者間，故其於「機械雲店中店」之銷售行為及收入，均應依其所屬國家、「產品」銷售國家及中華民國之法令，據實開立發票予使用者並繳納相關稅費。「開發者」應負責判斷「產品」是否需要課稅以及適用的稅率，並將稅費交付給相關稅務主管機關；若乙方或「管理者」依前述法令須代為扣繳或繳納者，「開發者」特此同意委由乙方或「管理者」逕自將所有稅費從售出「產品」的售價中扣除。
      </p>
      <h3>第三條：服務費用</h3>
      <p class="mt-1 mb-8">
        一、「開發者」透過「機械雲店中店」售出「產品」，乙方得自該之售出「產品」之售價中扣除售價之百分之○以為「服務費用」。<br />
        二、「帳款處理機構」之「服務費用」為「開發者」透過「機械雲店中店」□銷售「產品」之售價之百分之○；或□按筆收新台幣X元。<br />
        三、甲方「產品」為免費產品者，乙方得□免收；或□收取一定數額之「服務費用」，前述數額由「服務中心」另行公告。<br />
        四、甲方特此同意並委託「帳款處理機構」按月轉匯上個月份之乙方「服務費用」予乙方指定之匯款帳戶中。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;乙方匯款帳戶:<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;匯款帳號：<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;戶名: 財團法人工業技術研究院<br />
        五、本契約應支付乙方之款項，應以新台幣支付之。<br />
        六、因本契約所生之營業稅由甲方負擔。甲方應於支付本契約任一款項時，一併支付營業稅予乙方。
      </p>
      <h3>第四條：使用平台之行為</h3>
      <p class="mt-1 mb-8">
        一、「管理者」負責「機械雲店中店」之正常運作。如「機械雲店中店」有無法運作或程式錯誤（BUG）時，應予修復。<br />
        二、「帳款處理機構」應如實完成帳款服務。<br />
        三、「開發者」擔保其所有「產品」均無侵權之情事。<br />
        四、「開發者」同意其所有「產品」均應經「服務中心」審核通過後，始得上架進行銷售。審核未通過之「產品」，乙方不予上架，但得由雙方另行以書面協議後，依該協議另案協助導入甲方所有之網站。<br />
        五、「開發者」須負責將「產品」上傳至「機械雲店中店」、為使用者提供必要的「產品」資訊和支援服務，並如實公開「產品」在裝置上運作所需的權限。<br />
        六、「開發者」應於「產品」之詳細資訊網頁上，提供有效且正確的聯絡資訊，並加以維護，以便使用者在需要客服支援。<br />
        七、「開發者」必須對所有乙方核發之憑證加以保密，並對「產品」自行承擔全部責任。<br />
        八、「開發者」須遵守「機械雲店中店」與「服務中心」所訂定之「機械雲APP平台服務條款」、「開發者規範」及其它所有規定。<br />
        九、開發者規範包括，但不限於：技術規範；產品規範；資安規範；及其它規範。<br />
        例如：技術規範包括，但不限於以下之舉例事項：<br />
        （一）符合機械雲軟體架構的資料傳輸規範；<br />
        （二）符合機械雲計量計價相關軟體架構規範；<br />
        （三）符合機械雲資訊安全相關軟體架構規範；<br />
        （四）符合機械雲軟體架構下的相容性原則；及<br />
        （五）其它技術規範。
        十、「管理者」有權變動及更新本契約中所提及之相關網站位址及相關規範；「管理者」應將前述變動及更新於「服務中心」網站中公告。
      </p>
      <h3>第五條：使用者之個人資料與隱私權保護</h3>
      <p class="mt-1 mb-8">
        甲方應依法蒐集、處理及利用個人資料。甲方在透過「機械雲店中店」提供「產品」，並應保護使用者之隱私權和合法權利。如果使用者將自己的使用者名稱、密碼或其他登入資訊提供給甲方，或是甲方的「產品」會存取或使用這類資訊，甲方同意告知使用者其「產品」將能存取這類資訊，亦同意為使用者提供具有充分法律效力的隱私權聲明和保護措施。此外，甲方之「產品」僅可將這類資訊用於使用者授權的限定用途。
      </p>
      <h3>第六條：智慧財產權</h3>
      <p class="mt-1 mb-8">
        一、除雙方另有約定外，任一方均未授予他方實施其智慧財產權之權利。<br />
        二、甲方應遵守智慧財產權之相關法律，不得有侵害他人(以下簡稱「權利人」)智慧財產權之情事發生。經權利人通知甲方涉有侵權行為後，乙方有權移除或使他人無法進入該涉有侵權之內容「產品」或相關資訊。若甲方認其無侵權情事者，得檢具權利證明文件與未侵權通知文件（聲明及擔保無侵權情事，並願負擔因此所生之一切責任並賠償乙方或他人因此所受之一切損害），請求乙方回復其被移除或使他人無法進入之內容「產品」或相關資訊。若乙方於接獲前述甲方之文件後，將該前述文件轉送權利人，權利人於接獲乙方通知後之合理期間內，向乙方提出已對甲方訴訟或其它爭端解決程序之證明者，乙方不負回復之義務；若權利人未依前述期間提出相關之證明，乙方有權決定是否回復被移除或使他人無法進入之內容或相關資訊。
      </p>
      <h3>第七條：侵權責任</h3>
      <p class="mt-1 mb-8">
        甲方同意因其「產品」或其行為而引致之後果(包括乙方可能遭受的損失或損壞)承擔全部責任，乙方對甲方無須承擔任何責任。惟前述侵權行為係因可歸責於乙方之事由所致者，乙方得依甲方要求，提供諮詢等支援；因此所產生之費用，由甲方負擔。
      </p>
      <h3>第八條：特約條款</h3>
      <p class="mt-1 mb-8">
        一、非經乙方事前書面同意，甲方不得使用乙方、乙方之員工及乙方所屬各單位相同或類似之名稱、簡稱、照片、商標或標章。<br />
        二、甲方認知乙方為研究機構，並非營利性質法人，乙方係為扶植國內產業、加速我國產業技術發展而設，故甲方同意不論本契約存續與否或有無相反之約定，乙方依本契約及依有關法令之規定所應負擔之全部責任範圍，以本契約實際自甲方受領之「服務費用」總額百分之○為限。<br />
        三、有以下情形之一者，任一方得於事前60日以上以書面通知他方，終止本契約：<br />
        （一）若甲方擬退出「機械雲店中店」時；<br />
        （二）若政府機關或乙方認「機械雲店中店」無繼續運營之必要時。<br />
      </p>
      <h3>第九條：權義轉讓</h3>
      <p class="mt-1 mb-8">任一方依本契約對他方所得主張之權利及所應負擔之義務，非經雙方事前書面合意，不得轉讓予任何第三人。</p>
      <h3>第十條：聯絡管理</h3>
      <p class="mt-1 mb-8">
        一、本契約有關之通知或要求應以書面送達下列之處所及人員（以下簡稱「聯絡人」），經送達「聯絡人」者，即視為已送達該方當事人：<br />
        &nbsp;&nbsp;&nbsp;甲方：<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;姓名：○○○<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;職稱：○○○<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;聯絡電話：○○○<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;傳真：○○○<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;電子郵件：○○○<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;地址：○○○<br />
        &nbsp;&nbsp;&nbsp;乙方：<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;姓名：○○○<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;職稱：○○○<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;聯絡電話：○○○<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;傳真：○○○<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;電子郵件：○○○<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;地址：○○○<br />
        二、任一方之「聯絡人」或其職稱、聯絡電話、傳真、電子郵件或地址有變更時，應於變更後之七日內，以書面通知他方。否則，他方依變更前之資訊所為之通知或要求，仍生送達該方當事人之效力。
      </p>
      <h3>第十一條：違約效果</h3>
      <p class="mt-1 mb-8">
        一、任一方遲延支付他方任何一種款項累積達三十日以上時，他方得以書面終止本契約。<br />
        二、任一方違反權義轉讓之約定時，應支付他方○○元整，或應將其因違反前述約定所得之利益轉讓予他方，以為違約罰金，他方並得另以書面終止或解除本契約。<br />
        三、任一方違反本契約其他條款之約定或「機械雲店中店」與「服務中心」所訂定之「機械雲APP平台服務條款」、「開發者規範」及其它所有規定時，他方得以書面通知其於三十日內改正。逾期未改正者，他方得另以書面終止本契約。<br />
        四、任何一方重整或聲請或被聲請重整；解散或決議解散或被命令或裁定解散；合併或決議合併；破產或聲請或被聲請宣告破產；主要資產被查封；無法償還債務；或有相當事實足證有發生前述任一情事之虞；或股權結構中增加陸、港、澳投資人，且陸、港、澳投資人持有之股份累計達全部股份百分之十以上(下稱：股權變動)時，他方得以書面通知終止本契約。任一方於股權變動情事發生後三十日內，應以書面通知他方；他方僅得於該股權變動情事導致本契約有違反政府法令規定或損及我國整體產業及技術發展之情況下，始得終止本契約或以書面另議新約。<br />
        五、甲方遲延支付乙方任何一種款項時，乙方得自「機械雲店中店」上移除甲方之「產品」，直到甲方付清款項時為止。<br />
        六、如任一方確有侵權之情事，他方得立即終止本契約。
      </p>
      <h3>第十二條：終止效果</h3>
      <p class="mt-1 mb-8">
        一、本契約因任一方違約而終止或解除後，未違約方除得依本契約及有關法令之規定行使其權利外，並得向違約方請求賠償其所受之損害。本契約若非因乙方違約而終止或解除，甲方於本契約終止或解除前之給付義務不受影響。乙方經核算截至當時已完成之「服務費用」，如有不足之款項時，甲方仍應負有給付之義務。<br />
        二、本契約終止或解除後，甲方應立即停止行使其對「機械雲店中店」所得行使之權利，並應立即將乙方及「服務中心」提供之資料、文件等返還乙方，並銷毀或刪除其電子檔及複製本。
      </p>
      <h3>第十三條：生效日期</h3>
      <p class="mt-1 mb-8">
        本契約下列條款，不因本契約終止或解除而失效：智慧財產權、侵權責任、特約條款、保密條款、終止效果、合意管轄及其他依性質仍應存續之條款。
      </p>
      <h3>第十四條：契約修改</h3>
      <p class="mt-1 mb-8">本契約之增刪或修改，非經雙方當事人以書面協議之方式為之，不生效力。</p>
      <h3>第十五條：不可抗力</h3>
      <p class="mt-1 mb-8">
        因水災、火災、風災、地震或其他不可歸責於一方之事由，致其不能履行本契約或不能照本契約履行者，該方免給付義務或不負遲延責任。
      </p>
      <h3>第十六條：一部無效</h3>
      <p class="mt-1 mb-8">本契約部分條款依法被認為無效時，其他條款仍應繼續有效。</p>
      <h3>第十七條：條文名稱</h3>
      <p class="mt-1 mb-8">本契約各條文及項目之標題，僅係為方便閱讀之用，不得據以解釋、限制或影響各該條文或項目用語所含之意義。</p>
      <h3>第十八條：合意管轄</h3>
      <p class="mt-1 mb-8">若因本契約而涉訟時，甲乙雙方同意以新竹地方法院為第一審管轄法院。</p>
      <h3>第十九條：完整合意</h3>
      <p class="mt-1 mb-8">
        一、本契約本文及其附件構成雙方對本案完整之合意。任何於本契約生效前經雙方協議而未記載於本契約本文或其附件之事項，對雙方均無拘束力。<br />
        二、附件之效力與本契約之本文同，但兩者有牴觸時，以本契約本文為準。<br />
        三、本契約未盡事宜，雙方應本誠信原則互相協議解決。
      </p>
      <h3>第二十條：契約份數</h3>
      <p class="mt-1 mb-8">本契約壹式貳份，由甲乙雙方各執乙份為憑。</p>
      <p class="mt-1 mb-8">
        立約人：<br />
        &nbsp;&nbsp;甲方：○○○○○○公司<br />
        &nbsp;&nbsp;&nbsp;&nbsp;代表人：<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;姓名：<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;職稱：董事長<br />
        &nbsp;&nbsp;&nbsp;&nbsp;地址：○○○○○○<br />
        &nbsp;&nbsp;&nbsp;&nbsp;統一編號：○○○○○○<br /><br />
        &nbsp;&nbsp;乙方：財團法人工業技術研究院<br />
        &nbsp;&nbsp;&nbsp;&nbsp;代理人：<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;姓名：<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;職稱：院長<br />
        &nbsp;&nbsp;&nbsp;&nbsp;地址：新竹縣竹東鎮中興路四段一九五號<br />
        &nbsp;&nbsp;&nbsp;&nbsp;統一編號：02750963<br />
        &nbsp;&nbsp;&nbsp;&nbsp;工研院顧客服務專線：0800-45-8899<br /><br />
        中華民國○○○年○○月○○日
      </p>
    </div>
    <p class="text-caption">註：平台有權依實際狀況對條款內容進行更新</p>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="_blue" outlined text @click="$emit('close')">{{ $t('disagree') }}</v-btn>
      <v-btn class="_blue white--text" text @click="$emit('agree')">{{ $t('agree') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {};
</script>
